import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import moment from "moment-hijri";
import DatePicker from "react-multi-date-picker";
import arabic from "react-date-object/calendars/arabic";
import arabic_ar from "react-date-object/locales/arabic_en";
import { SERVER_URL } from '../ConstantsEN';
import { DateHijriDifferences_EndPoint } from '../ConstantsEN';
import { CalculatorsType } from '../ConstantsEN';
import SharedHelmet from "../Helmet";
const TITLE = 'Calculate the Difference Between Two Dates or Ages in Hijri Calendar';
const DESCRIPTION = 'Calculate the duration between two dates, whether in Hijri or Gregorian calendar, and also calculate the number of days between two dates using the Days Calculator. Determine the elapsed and remaining time between any two dates.';
const KEYWORDS = 'Calculate Age Differences, Calculate Date Differences, Calculate Age in Hijri, Calculate Age Differences in Gregorian, Age Calculator, Date Calculator, Calculate Age in Hijri Calendar, Calculate Age Between Two Dates';
const OG_URL = 'https://do-calculate.com/calculator/en/datehijridifferences/';
moment.locale("ar");
const apiEndpoint = `${SERVER_URL}/${DateHijriDifferences_EndPoint}`;
function DateDifferencesCalculatorHijri() {
    const [differences, setDifferences] = useState(null);
    const [statusCode, setStatusCode] = useState(null);
    const [date1, setDate1] = useState(null);
    const [date2, setDate2] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const calculateDifferences = async () => {
        setIsLoading(true);
        try {
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ date1: date1.format('YYYY-MM-DD'), date2: date2.format('YYYY-MM-DD') }),
            });
            const data = await response.json();
            setStatusCode(response.status);
            if (response.ok) {
                setDifferences(data.differences);
            } else {
                setDifferences(null);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setIsLoading(false);
        }
    };
    return (
        <div>
  <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
            <div className="row">
                <div className="col-12 col-md-8">
                <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px', }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        Calculate the duration between two dates, whether in Hijri or Gregorian calendar, and also calculate the number of days between two dates using the Days Calculator. Determine the elapsed and remaining time between any two dates.
                                        <br/>                                    </div>
                                    <br />
                                </div>
                                <br /><hr />
                                <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="dateOfBirth1" style={{ fontSize: '16px' }}>Enter the First Date in Hijri Calendar</label>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <DatePicker
                                                value={date1}
                                                id="dateOfBirth1"
                                                calendar={arabic}
                                                locale={arabic_ar}
                                                onChange={setDate1}
                                            />
                                        </div>
                                    </div>
                                </div> <br /><hr />
                                <div className="row">
                                    <div className="col">
                                        <label htmlFor="dateOfBirth2" style={{ fontSize: '16px' }}>Enter the Second Date in Hijri Calendar</label>
                                    </div>
                                    <div className="col">
                                        <div className="form-group">
                                            <DatePicker
                                                value={date2}
                                                calendar={arabic}
                                                id="dateOfBirth2"
                                                locale={arabic_ar}
                                                onChange={setDate2}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <br /><hr />
                                <div className="row">
                                    <div className="col" className='text-center'>
                                        <br />
                                        <button className="btn btn-success" style={{ fontSize: '20px' }} onClick={calculateDifferences} disabled={isLoading}>
                                            {isLoading ? (
                                                <div className="spinner-border spinner-border-sm" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            ) : (
                                                'Calculate'
                                            )}
                                        </button>
                                        <br />
                                    </div>
                                    <hr />
                                    <div className="row">
                                        <RelatedLinks />
                                        <br />
                                        <hr />
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <br />
                                            {statusCode === 400 && <div className="alert alert-warning"><b><u>Error:</u></b> Please enter a valid birthdate.</div>}
                                            {differences && (
                                                <div>
                                                    <br />
                                                    <div style={{ backgroundColor: '#D1E7DD', borderColor: '#c3e6cb', color: '#155724', padding: '15px', marginBottom: '20px', borderRadius: '4px' }}> <label >
                                                        <b> The Difference is:   </b>
                                                        {differences.years} years
                                                        and {differences.months} months
                                                        and {differences.days} days
                                                        and {differences.hours} hours
                                                        and {differences.minutes} minutes
                                                        and {differences.seconds} seconds
                                                    </label>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.humanCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
            <div className="row" style={{ height: 'auto' }} >
                <div className="col-12 col-md-8">
                <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">Difference Between Two Dates in the Gregorian Calendar: Calculating Age Difference Between Two Individuals</div>
                            <div className="info-section-body">
                                <u><h2 style={{ fontSize: '16px' }}>Age in the Hijri Calendar: Conversion and Accurate Calculation</h2></u>
                                <p>
                                    Age is an important aspect of a person's life, reflecting their experiences and maturity over time. Calculating the difference between two dates in the Gregorian calendar requires precise knowledge of the dates and the ability to convert them into a simple time difference. In this article, we will take a look at how to calculate the age difference between two individuals or between specific dates in the Gregorian calendar.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>The Basic Concept of Age Calculation</h2></u>
                                <p>
                                    Calculating the difference in ages is the process of determining the number of years, months, and days that separate two specific dates in the Gregorian calendar. This calculation can be used in various contexts, such as calculating the age difference between two individuals or knowing the age gap between important dates like graduation or any other occasion.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How to Calculate Age Difference Between Birthdates</h2></u>
                                <p>
                                    To calculate the age difference between specific birthdates in the Gregorian calendar, you can follow these steps:
                                </p>
                                <ul>
                                    <li>
                                        Specify the dates: Start by specifying the dates for which you want to calculate the difference.
                                    </li>
                                    <li>
                                        Convert the dates to days: Simply convert each date into a number of days. For example, you can convert each date into the number of days from the beginning of the calendar.
                                    </li>
                                    <li>
                                        Calculate the difference: Subtract one day count from the other to get the age difference in days.
                                    </li>
                                    <li>
                                        Convert the age difference: You can convert the age difference in days into months or years by dividing by the number of days in a month or year. For example, there are about 30 days in a month.
                                    </li>
                                </ul>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>Uses of Age Calculation</h2></u>
                                <p>
                                    Age calculation can be used in various contexts, such as calculating the age difference between two individuals in a relationship or to determine the age gap between significant dates like wedding dates or moving to a new house. It can also be used in administrative and statistical aspects.
                                </p>
                                <hr />
                                <u><h2 style={{ fontSize: '16px' }}>How to Use the Age Difference Calculator Between Two Ages or Dates in the Hijri Calendar</h2></u>
                                <p>
                                    The use of the Hijri calendar to calculate a person's age dates back to Islamic history. The Hijri calendar is based on the migration of Prophet Muhammad (peace be upon him) from Mecca to Medina in the year 622. The Hijri year consists of 12 months, and the number of days in each month varies according to the Hijri calendar. The Hijri year is shorter than the Gregorian year, so the dates differ between the two years.
                                </p>
                                <p>
                                    This calculator aims to calculate the differences between two dates in the Hijri calendar. The two dates are passed to the function as Hijri dates, such as birthdate and the current date.
                                </p>
                                <p>
                                    When executed, the calculator compares the two dates and calculates the differences in years, months, days, hours, minutes, and seconds between them. Once finished, you will get values representing the differences in each time unit.
                                </p>
                            </div>
                        </div>
                    </div>
                    <br />
                    <u><h2>Frequently Asked Questions</h2></u>
                    <br />
                    <div className="info-sections-container">
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Is the Calculation of Age Difference Between Two Individuals in the Hijri Calendar?</h3>
                            </div>
                            <div className="info-section-body">
                                Calculating the age difference between two individuals in the Hijri calendar is the process of determining the time difference between the birthdates of these individuals in this calendar. This difference can be in years, months, and days.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>How Can the Age Difference Between Two Individuals in the Hijri Calendar Be Calculated?</h3>
                            </div>
                            <div className="info-section-body">
                                You can calculate the age difference between two individuals or two dates in the Hijri calendar by following these steps:
                                <ol>
                                    <li>Specify the birthdates of the individuals or the dates for which you want to calculate the difference.</li>
                                    <li>Convert those dates into Hijri dates using conversion tables or available online tools.</li>
                                    <li>Subtract the Hijri dates to obtain the difference in days.</li>
                                    <li>If desired, convert the difference in days into years and months.</li>
                                </ol>
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Is There a Calculator to Calculate the Age Difference Between Two Individuals in the Hijri Calendar?</h3>
                            </div>
                            <div className="info-section-body">
                                Yes, you can find online calculators that help you quickly and easily calculate the age difference between two dates in the Hijri calendar. All you need to do is enter the Hijri dates, and you will get an accurate difference.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>What Is the Importance of Calculating the Age Difference Between Two Individuals in the Hijri Calendar?</h3>
                            </div>
                            <div className="info-section-body">
                                Calculating the age difference between two individuals or two dates in the Hijri calendar can be useful in various contexts. You can find out the age difference between people in a relationship or determine the time gap between significant events such as weddings or for other purposes.
                            </div>
                        </div>
                        <div className="info-section">
                            <div className="info-section-header">
                                <h3 style={{ fontSize: '16px' }}>Can the Age Difference Between Two Individuals in the Hijri Calendar Be Calculated Manually?</h3>
                            </div>
                            <div className="info-section-body">
                                Yes, you can manually calculate the age difference between two individuals in the Hijri calendar by knowing the Hijri dates and using recognized Gregorian calendar rules. It may require some time and effort, but it is technically possible.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default DateDifferencesCalculatorHijri;
